export default "__VITE_ASSET__daeef17e__"